import React, { useState } from 'react';
import { createComplianceAcknowledgment } from '../../../../api/conversations';

import styles from './index.module.css';

const BYLVAY_ISI_URL = 'https://www.bylvay.com/#important-safety-information';

const BYLVAY_FPI_URL =
  'https://d2rkmuse97gwnh.cloudfront.net/a88aa6d6-3ca0-4362-a711-d53c45ae33ff/5f7d23c0-f85b-4f9a-907a-3f2fa18aa260/5f7d23c0-f85b-4f9a-907a-3f2fa18aa260_source__v.pdf';

const COPY = {
  bylvay: {
    patient: {
      title: 'Before You Begin',
      body: (
        <>
          <p>
            Ipsen, the company that makes BYLVAY (odevixibat), sponsors this mentor program. You'll be connected with a
            mentor who has experience with BYLVAY and is compensated for their time.
          </p>
          <p>
            Mentors share their personal experience and aren't able to provide medical advice. For any questions about
            treatment, side effects, or safety, please reach out to your healthcare provider, and refer to the{' '}
            <a href={BYLVAY_ISI_URL} target='_blank' rel='noreferrer' className={styles.isi_link}>
              Important Safety Information
            </a>
            . Please see full{' '}
            <a href={BYLVAY_FPI_URL} target='_blank' rel='noreferrer' className={styles.isi_link}>
              Prescribing Information
            </a>{' '}
            here.
          </p>
        </>
      ),
    },
    mentor: {
      title: 'Before You Begin',
      body: (
        <p>
          Before beginning this conversation, you acknowledge that you can share only your personal experience, not
          medical advice. If the participant has questions regarding dosing, side effects, treatment decisions, or
          safety, encourage them to speak with their healthcare provider or refer to the{' '}
          <a href={BYLVAY_ISI_URL} target='_blank' rel='noreferrer' className={styles.isi_link}>
            Important Safety Information
          </a>
          . Please see full{' '}
          <a href={BYLVAY_FPI_URL} target='_blank' rel='noreferrer' className={styles.isi_link}>
            Prescribing Information
          </a>{' '}
          here.
        </p>
      ),
    },
  },
};

export default function ComplianceAcknowledgmentModal({ conversationUuid, accountSlug, role, onAcknowledged }) {
  const [loading, setLoading] = useState(false);

  const copy = COPY[accountSlug]?.[role];

  const handleAcknowledge = () => {
    setLoading(true);
    createComplianceAcknowledgment(
      conversationUuid,
      (data) => {
        setLoading(false);
        onAcknowledged(data.acknowledged_at);
      },
      () => {
        setLoading(false);
      }
    );
  };

  if (!copy) return null;

  return (
    <div className={`${styles.modal_container} platform-modal container-fluid`}>
      <div className={`${styles.modal} ${styles.wide_modal}`}>
        <div className={styles.modal_body_wrap}>
          <div className={styles.modal_banner}>
            <p className={styles.banner_text}>{copy.title}</p>
          </div>
          <div className={styles.content}>
            <div className={styles.body}>{copy.body}</div>
            <div className={styles.cta_wrap}>
              <button className={styles.acknowledge_button} onClick={handleAcknowledge} disabled={loading}>
                {loading ? 'Saving...' : 'I Acknowledge'}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
